module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAmCAMAAAAcJyCnAAAAY1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+aRQ2gAAAAIHRSTlMAEZYiM6Ux6wUO+4MKwJ8s9OHa1Me2qo12dGhLRz2/oePrXTcAAACpSURBVCjPzdNJDsMgDEBRt5CEKfM8tb7/KavWMtCIA+QvnxALy4Zvjzig8gLjioNejn9qaqC2JtJFTSexGDyWyuIM/LmkciUNPuGa6zChFlOa3UDfSc3boE5wWlesIoy4B9glaYm+Fbg1YEkid4DeYyFIn1hpLTgHrNjW4AuKVVKzG6hNaecSaqTy+8Q6o1Uv5AZBek5qwVCzAVUbjBv1T4/LBeQA6Wv5AAWvHXjwZ5shAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/progressPage/num-2.png
// module id = 1D6T
// module chunks = 1